export default __webpack_public_path__ + "static/media/disclaimer.eb30c093.jpeg";